/* Progressive enhancement only. Product forms and media stay under Shopify's native controllers. */
(() => {
  if (customElements.get('nv-product-tabs')) return;
  class NuvoriteProductTabs extends HTMLElement {
    connectedCallback() {
      if (this.cleanup) return;
      const nav = this.querySelector('[role="tablist"]');
      const tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      const panels = Array.from(this.querySelectorAll('[data-nv-panel]'));
      if (!nav || !tabs.length || tabs.length !== panels.length) return;
      const select = (index, focus = false) => {
        tabs.forEach((tab, i) => {
          tab.setAttribute('aria-selected', String(i === index));
          tab.tabIndex = i === index ? 0 : -1;
          panels[i].hidden = i !== index;
          panels[i].setAttribute('role', 'tabpanel');
          panels[i].setAttribute('aria-labelledby', tab.id);
          panels[i].tabIndex = 0;
        });
        if (focus) tabs[index].focus({ preventScroll: true });
      };
      const click = event => {
        const index = tabs.indexOf(event.target.closest('[role="tab"]'));
        if (index !== -1) select(index);
      };
      const keydown = event => {
        const index = tabs.indexOf(event.target);
        if (index === -1) return;
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        else if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = tabs.length - 1;
        else return;
        event.preventDefault();
        select(next, true);
      };
      nav.addEventListener('click', click);
      nav.addEventListener('keydown', keydown);
      nav.hidden = false;
      select(0);
      this.cleanup = () => {
        nav.removeEventListener('click', click);
        nav.removeEventListener('keydown', keydown);
      };
    }
    disconnectedCallback() {
      this.cleanup?.();
      this.cleanup = null;
    }
  }
  customElements.define('nv-product-tabs', NuvoriteProductTabs);
})();
